(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.service('$Products', function($firebaseArray, $firebaseObject) {
        var fireRef = firebase.database().ref().child('products');

        return {
            ref: fireRef,
            get: function(id) {
                return $firebaseObject(fireRef.child(id));
            },
            set: function(obj) {
                if(_.has(obj, '$id')){
                    return obj.$save();
                } else {
                    return fireRef.push(obj);
                    //this.add(obj);
                }
            },
            add: function (obj) {
                return this.set(obj);
                // if(_.has(obj, '$id')){
                //     return obj.$save();
                // } else {
                //     return fireRef.push(obj);
                // }
            },
            all: function() {
                return $firebaseArray(fireRef);
            },
            // all: list,
            findByName: function(str) {
                var data = [];

                if (str) {
                    var query = fireRef.orderByChild('name').equalTo(str);
                    query.on("child_added", function(snapshot) {
                      data.push(snapshot.val());
                    });
                } else {
                    return $firebaseArray(fireRef);
                }

                return data;
            },
        };

    });
})();
